//React Redux
import React, { Component } from 'react'
import { connect } from 'react-redux';

//Material Components
import Grid from '@material-ui/core/Grid';


//Actions
import { SetHeaderButtons } from '../../actions/headerButtonsActions';
import { GetAllVersions } from '../../actions/versionActions';

//views
import AddVersion from '../version/version'
import VersionList from '../version/VersionList'


export class VersionPage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            //Add version page
            openAddEditVersionPage: false,
            versionSelected: undefined,
        }


    };


    componentDidMount() {

        this.props.GetAllVersions();
    };

    componentWillUnmount() {

    }



    //#region HANDLERS
    AddVersionHandler = () => {
        try {
            this.setState({ openAddEditVersionPage: true })
        } catch (err) { }
    }

    resize() {
        this.setState({ isMobile: window.innerWidth <= 960 });

        const sizes = {
            xs: {
                name: 'xs',
                fontSize: '58%',
                maxWidht: 600,
            },
            sm: {
                name: 'sm',
                fontSize: '60%',
                maxWidht: 1024,
            },
            md: {
                name: 'md',
                fontSize: '80%',
                maxWidht: 1880,
            },
            lg: {
                name: 'lg',
                fontSize: '100%',
                maxWidht: 1920,
            },
        };

        const windowWidht = window.innerWidth;
        const windowHeiht = window.innerHeight;

        let rootFontSize = sizes.xs;

        if (windowWidht > sizes.md.maxWidht) {
            rootFontSize = sizes.lg;
        } else if (windowWidht > sizes.sm.maxWidht) {
            rootFontSize = sizes.md;
        } else if (windowWidht > sizes.xs.maxWidht) {
            rootFontSize = sizes.sm;
        } else {
            rootFontSize = sizes.xs;
        }


        this.setState({
            rootFontSize: rootFontSize,
            windowWidht: windowWidht,
            windowHeiht: windowHeiht,
        });
    }


    //#region HANDLERS
    openEditVersionPageHandler = (versionObj) => {

        this.setState({ versionSelected: versionObj, openAddEditVersionPage: true })

    }

    cleanVersion = () => {
        this.setState({ versionSelected: undefined })
    }
    //#endregion
    render() {
        return (
            <Grid>
                {
                    !this.state.openAddEditVersionPage ?
                        <VersionList
                            cleanVersion={this.cleanVersion}
                            AddVersionHandler={this.AddVersionHandler}
                            stagingVersions={this.props.stagingVersions ? this.props.stagingVersions : []}
                            productionVersions={this.props.productionVersions ? this.props.productionVersions : []}
                            openEditVersionPageHandler={this.openEditVersionPageHandler}
                        />
                        :
                        <AddVersion
                            versionSelected={this.state.versionSelected ? this.state.versionSelected : undefined}
                            closeAddEditPage={() => this.setState({ openAddEditVersionPage: false })}
                        />
                }
            </Grid>
        )

    }
}


function mapStateToProps(state) {

    let stagingVersions = (state.ehubVersionReducer && state.ehubVersionReducer.ehubVErsionData) ? state.ehubVersionReducer.ehubVErsionData.filter(version => version.version && version.version.flavor === 'staging') : [];
    let productionVersions = (state.ehubVersionReducer && state.ehubVersionReducer.ehubVErsionData) ? state.ehubVersionReducer.ehubVErsionData.filter(version => version.version && version.version.flavor === 'production') : [];;

    if (Array.isArray(stagingVersions) && stagingVersions.length > 0)
        stagingVersions = stagingVersions.sort((a, b) => (a.createdAt < b.createdAt) ? 1 : -1)

    if (Array.isArray(productionVersions) && productionVersions.length > 0)
        productionVersions = productionVersions.sort((a, b) => (a.createdAt < b.createdAt) ? 1 : -1)

    return {
        stagingVersions: stagingVersions,
        productionVersions: productionVersions,
    }

};

export default connect(mapStateToProps, { SetHeaderButtons, GetAllVersions })(VersionPage);
